(function() {
  angular.module('forgotUser')
  .factory('forgotUserFactory', ['$resource', function($resource) {
    return $resource('/dnUsers');
  }]);
})();
